<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/swiper.png" /></div>
      <p>Swiper</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/swiper/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "4.4.1",
          linkList: [ur + "4.4.1/swiper.min.css", ur + "4.4.1/swiper.min.js"]
        },
        {
          label: "4.2.2",
          linkList: [ur + "4.2.2/swiper.min.css", ur + "4.2.2/swiper.min.js"]
        },
        {
          label: "8.4.2",
          linkList: [
            ur + "8.4.2/swiper-bundle.min.css",
            ur + "8.4.2/swiper-bundle.min.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListSwiper.vue